import { useContext } from 'react';

import LocaleContext from '@frolight/context/LocaleProvider';

const useLocaleUpdater = () => {
  return useContext(LocaleContext);
}

export default useLocaleUpdater;
